import { MsalRoleContext, UserContext } from '@ab-inbev/sam-auth';
import React, { FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { getRoleNames, mapBreweryRoleToBreweryCode } from './userProfileSettings/permissionsUtils';
import beerMug from '../assets/beerMug.png';
import { AppName } from './userProfileSettings/types';

type UserInfoDisplayProps = {
  appName?: AppName;
  permissionOrder?: string[];
};

export const UserInfoDisplay: FC<UserInfoDisplayProps> = ({ appName, permissionOrder }) => {
  const i18next = useTranslation();
  const userContext = useContext(UserContext);
  const userRoles = useContext(MsalRoleContext);
  const userDisplayName = userContext?.user?.name ?? '';

  // In reality, there should be 0 or 1 of these. But if there are more, I guess we'll show them all.
  const breweryRoles = userRoles
    .filter((role) => /App.All.Brewery/.test(role))
    .map((role) => mapBreweryRoleToBreweryCode(role))
    .filter((role) => role !== '')
    .join(', ');

  return (
    <div className="user-info-display">
      <img
        className="user-profile-action-drawer-button-profile-image"
        src={beerMug}
        alt="Default 'Mug of Beer' Profile Icon"
      />
      <div>
        {<div className="user-profile-action-drawer-button-username">{userDisplayName}</div>}
        {appName && (
          <div className="user-profile-roles">{getRoleNames({ userRoles, appName, i18next, permissionOrder })}</div>
        )}
        {appName && (
          <div className="user-profile-brewery-roles">{`${i18next.t('userProfile.breweryRole')}: ${breweryRoles}`}</div>
        )}
      </div>
    </div>
  );
};
